"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const columnTitles_1 = __importDefault(require("./columnTitles"));
const tooltipTitles_1 = __importDefault(require("./tooltipTitles"));
const hintTitles_1 = __importDefault(require("./hintTitles"));
const rowsControlsTitles_1 = __importDefault(require("./rowsControlsTitles"));
const confirmTitles_1 = __importDefault(require("./confirmTitles"));
const errorTooltips_1 = __importDefault(require("./errorTooltips"));
const modals_1 = __importDefault(require("./modals"));
const filterTitles_1 = __importDefault(require("./filterTitles"));
const footer_1 = __importDefault(require("./footer"));
const statistics_1 = __importDefault(require("./statistics"));
const messageTexts_1 = __importDefault(require("./messageTexts"));
const header_1 = __importDefault(require("./header"));
const ownershipsMerge_1 = __importDefault(require("./ownershipsMerge"));
const joiningRequestsDialog_1 = __importDefault(require("./joiningRequestsDialog"));
const rowsDelete_1 = __importDefault(require("./rowsDelete"));
const rowsClear_1 = __importDefault(require("./rowsClear"));
const notifyModal_1 = __importDefault(require("./notifyModal"));
const historyFilters_1 = __importDefault(require("./historyFilters"));
const subHeader_1 = __importDefault(require("./subHeader"));
const errorBlock_1 = __importDefault(require("./errorBlock"));
const errorModal_1 = __importDefault(require("./errorModal"));
const ownershipEditor_1 = __importDefault(require("./ownershipEditor"));
exports.default = {
  messageTexts: messageTexts_1.default,
  columnTitles: columnTitles_1.default,
  tooltipTitles: tooltipTitles_1.default,
  hintTitles: hintTitles_1.default,
  rowsControlsTitles: rowsControlsTitles_1.default,
  confirmTitles: confirmTitles_1.default,
  errorTooltips: errorTooltips_1.default,
  modals: modals_1.default,
  filterTitles: filterTitles_1.default,
  footer: footer_1.default,
  statistics: statistics_1.default,
  header: header_1.default,
  ownershipsMerge: ownershipsMerge_1.default,
  joiningRequestsDialog: joiningRequestsDialog_1.default,
  rowsDelete: rowsDelete_1.default,
  rowsClear: rowsClear_1.default,
  notifyModal: notifyModal_1.default,
  historyFilters: historyFilters_1.default,
  subHeader: subHeader_1.default,
  errorBlock: errorBlock_1.default,
  errorModal: errorModal_1.default,
  ownershipEditor: ownershipEditor_1.default
};